import LocationList from '../pages/Locations/LocationList';
import LocationDetail from '../pages/Locations/LocationDetail';
import LocationForm from '../pages/Locations/LocationForm';
import LocationQrPrint from '../pages/Locations/LocationQrPrint';
import RestaurantList from '../pages/Restaurants/RestaurantList';
import RestaurantDetail from '../pages/Restaurants/RestaurantDetail';
import RestaurantForm from '../pages/Restaurants/RestaurantForm';
import { OWNER_ABOVE, STAFF_ABOVE } from '../constants/roles';
import RoleProtectedRoute from '../components/RoleProtectedRoute';
import type { AppRoute } from './types';

const ADMIN = ['Admin'] as const;

export const locationsRoutes: AppRoute[] = [
    {
        path: 'restaurants',
        children: [
            { index: true, element: <RoleProtectedRoute allowedRoles={ADMIN} Component={RestaurantList} /> },
            { path: ':id', element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={RestaurantDetail} /> },
            { path: 'create', element: <RoleProtectedRoute allowedRoles={ADMIN} Component={RestaurantForm} /> },
            { path: 'edit/:id', element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={RestaurantForm} /> },
        ],
    },
    {
        path: 'locations',
        children: [
            { index: true, element: <RoleProtectedRoute allowedRoles={STAFF_ABOVE} Component={LocationList} /> },
            { path: 'create', element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={LocationForm} /> },
            { path: 'edit/:id', element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={LocationForm} /> },
            { path: ':id', element: <RoleProtectedRoute allowedRoles={STAFF_ABOVE} Component={LocationDetail} /> },
        ],
    },
    {
        path: 'locations/:id/qr/print',
        handle: { standalone: true },
        element: <RoleProtectedRoute allowedRoles={STAFF_ABOVE} Component={LocationQrPrint} />,
    },
];
